module.exports = __webpack_public_path__ + "img/link-pocket-mobile_en.57aaf05.jpg";